import type { FileItem } from "../../types";
import { GalleryItem } from "./GalleryItem";

interface GalleryGridProps {
  files: FileItem[];
  selectedFile: FileItem | null;
  selectedFileIds?: Set<string>;
  onFileSelect: (file: FileItem) => void;
  onMultiSelect?: (file: FileItem, checked: boolean) => void;
  onImageClick?: (file: FileItem) => void;
  isLargeGallery: boolean;
}

export function GalleryGrid({
  files,
  selectedFile,
  selectedFileIds,
  onFileSelect,
  onMultiSelect,
  onImageClick,
  isLargeGallery,
}: GalleryGridProps) {
  const baseClasses =
    "grid w-full max-w-full items-stretch justify-items-stretch gap-3 overflow-auto rounded-md contain-inline-size 2xl:gap-4";
  const columnClasses = isLargeGallery
    ? "grid-cols-[repeat(auto-fill,minmax(280px,1fr))]"
    : "grid-cols-[repeat(auto-fill,minmax(220px,1fr))]";

  return (
    <div className={`${baseClasses} ${columnClasses}`}>
      {files.map((file) => (
        <GalleryItem
          key={file.id}
          file={file}
          useLargeThumbnail={true}
          isLargeGallery={isLargeGallery}
          isSelected={selectedFile?.id === file.id}
          isMultiSelected={selectedFileIds?.has(file.id) || false}
          onFileSelect={onFileSelect}
          onMultiSelect={onMultiSelect}
          onImageClick={onImageClick}
        />
      ))}
    </div>
  );
}
